import { useState } from "react"
import { TooltipButton } from "@/v2-backoffice-client/components/button"
import type { TooltipButtonProps } from "@/v2-backoffice-client/components/button"
import LayerForkDialog from "@/v2-backoffice-client/layer/fork/LayerForkDialog"
import type { LayerFragment } from "@/v2-backoffice-client/layer/__types__/layer.fragment"

export type LayerForkButtonProps = Omit<TooltipButtonProps, "content"> & {
  layer: LayerFragment
}

/**
 * Opens the fork dialog: copies this layer's entire setup into a new layer
 * that can take a different direction. The fork lands in the review queue.
 */
function LayerForkButton(props: LayerForkButtonProps) {
  const { layer, children, ...buttonProps } = props

  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      <TooltipButton
        variant="ghost"
        isStacked
        iconSrc="code-fork"
        content="Copy this layer's entire setup into a new layer that can take a different direction. The fork lands in the review queue."
        data-feature-code="UI_BackofficeLayers_Toolbar_Fork"
        onClick={() => setIsOpen(true)}
        {...buttonProps}
      >
        {children ?? "Fork"}
      </TooltipButton>
      <LayerForkDialog layer={layer} open={isOpen} onOpenChange={setIsOpen} />
    </>
  )
}

export default LayerForkButton
